import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { changeHomeInitialState, changeSansthaId } from "../../../store/cms/cmsSlice";
import sansthaApis from "../../../store/sanstha/sansthaApis";

const mapStateToProps = (state) => {
    return {
        homeInitialValues: state.cms.homeInitialValues,
        sansthaId: state.cms.sansthaId,
    };
};

const mapDispatch = {
    changeHomeInitialState,
    changeSansthaId,
    getSansthaList: sansthaApis.endpoints.getSansthaList.initiate,
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(mapDispatch, dispatch);

const Store = (Container) =>
    connect(mapStateToProps, mapDispatchToProps)(Container);

export default Store;